import { TFunction } from "i18next";
import * as Yup from "yup";

export const getClaimRequestTypeFormSchema = (t: TFunction) => {
    return Yup.object().shape({
        description: Yup.object()
            .shape({
                catalan: Yup.string()
                    .trim()
                    .required(t("common:form.requiredFieldForm")),
                spanish: Yup.string()
                    .trim()
                    .required(t("common:form.requiredFieldForm")),
                english: Yup.string()
                    .trim()
                    .required(t("common:form.requiredFieldForm")),
                french: Yup.string()
                    .trim()
                    .required(t("common:form.requiredFieldForm")),
            })
            .required(t("common:form.requiredFieldForm")),
        maximumDaysToRespond: Yup.number()
            .nullable()
            .notRequired()
            .min(1, t("common:form.valueMustBeGreatherOrEqualThan", { num: 1 })),
        daysToRemindDeadline: Yup.number()
            .nullable()
            .notRequired()
            .transform((value, originalValue) => 
                originalValue === "" || originalValue === null ? null : value
            )
            .min(1, t("common:form.valueMustBeGreatherOrEqualThan", { num: 1 }))
            .when("maximumDaysToRespond", ([maximumDaysToRespond], schema) =>
                maximumDaysToRespond
                    ? schema.test(
                        "daysToRemindDeadline-after-maximumDaysToRespond",
                        t("common:form.valueMustBeLessThan", { num: 1 }),
                        (daysToRemindDeadline) => {
                            if (!daysToRemindDeadline || isNaN(daysToRemindDeadline)) return true;
                            return maximumDaysToRespond > daysToRemindDeadline;
                        }
                    )
                    : schema
            )
    });
};